import settings from './settings';

let jq;

const init = ($, currentStep = 0) => {
  jq = $;
  showInvite();
  initProgress();
};

const showInvite = () => {
  const $popup = jq('#tutorialPopup')
  $popup.on('shown.bs.modal', () => {
    $popup.find('.skip-tour').on('click', async e => {
      e.preventDefault();
      e.stopPropagation();

      jq(e.target).addClass('d-none');

      $popup.find('.fa-spin').removeClass('d-none');

      await completeTour('skip');

      $popup.find('.fa-spin').addClass('d-none');
      $popup.modal('hide');
    });

    $popup.find('#startTour').on('click', e => {
      e.preventDefault();
      e.stopPropagation();

      $popup.modal('hide');

      showStep(window.tourStep);
    });
  });

  $popup.modal({backdrop: 'static', keyboard: false});
  $popup.modal('show');

};

const showStep = step => {
  console.log('show step', step)
  if(settings.length && settings[step] != undefined) {

    settings.forEach(item => {
      jq(item.blockSelector).removeClass('tutorial-block');
    });

    const stepData = settings[step];

    setProgressStep(step, stepData);

    if(stepData.callback) {
      stepData.callback(jq);
    }

    const $itemEl = jq(stepData.itemSelector)

    $itemEl.tooltip('dispose');
    $itemEl.css('pointer-events', 'none');
    $itemEl.tooltip({
      html: true,
      template: `<div class="tutorial tooltip" role="tooltip"><div class="arrow"></div><div class="tutorial-wrapper"><span>Step ${stepData.step} of ${stepData.total}</span><div class="tooltip-inner"></div></div></div>`,
      title: `<h2>${stepData.title}</h2><p>${stepData.text}</p><div class="mt-4"><a class="btns skip mr-3">Exit tour</a><a class="btns white next">Next</a></div>`,
      placement: stepData.placement || 'right'
    });
    $itemEl.tooltip('show');

    $itemEl.addClass('tutorial-active');

    jq(stepData.blockSelector).addClass('tutorial-block');

    $itemEl.on('shown.bs.tooltip', () => {
      jq('body').addClass('in-tutorial');

      const $actionButton = jq('.tutorial').find('a.next');
      const $skipButton = jq('.tutorial').find('a.skip');

      const elRect = document.querySelector('.tutorial').getBoundingClientRect();
      const el1Rect = document.querySelector('.tutorial-active').getBoundingClientRect();
      window.scrollTo({
        top: Math.min(elRect.top, el1Rect.top) - 25,
        left: Math.min(elRect.left, el1Rect.left),
        behavior: 'smooth'
      })

      if($actionButton.length) {
        $actionButton.on('click', async e => {
          e.preventDefault();
          e.stopPropagation();
          if(settings[step + 1] != undefined) {
            $itemEl.tooltip('dispose');
            $itemEl.css('pointer-events', 'all');
            $itemEl.removeClass('tutorial-active');
            showStep(step + 1)
            await completeTour(step);
          } else {
            $itemEl.tooltip('dispose');
            $itemEl.removeClass('tutorial-active');
            jq('body').removeClass('in-tutorial');
            jq(stepData.blockSelector).removeClass('tutorial-block');
            await completeTour('complete');

          }
        });
      }

      if($skipButton.length) {
        $skipButton.on('click', async e => {
          e.preventDefault();
          e.stopPropagation();
          $itemEl.tooltip('dispose');
          $itemEl.removeClass('tutorial-active');
          jq('body').removeClass('in-tutorial');
          jq(stepData.blockSelector).removeClass('tutorial-block');
          await completeTour(`skip_${step}`);
        });
      }

    });

    $itemEl.on('hide.bs.tooltip', () => {
      const $actionButton = jq('.tutorial').find('a.next');
      const $skipButton = jq('.tutorial').find('a.skip');
      if($actionButton.length) {
        $actionButton.off('click');
      }
      if($skipButton.length) {
        $skipButton.off('click');
      }
    });
  }
};

const completeTour = async status => {
  var CSRF_TOKEN = jq('meta[name="csrf-token"]').attr('content');
  return await fetch('/auth/members/complete-tour', {
    method: 'POST',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json'
    },
    redirect: 'follow',
    body: JSON.stringify({
      status,
      _token: CSRF_TOKEN
    })
  });
};

const initProgress = () => {
  jq('.toggle-collapse').on('click', e => {
    e.preventDefault();
    e.stopPropagation();

    jq('.tutorial-progress').toggleClass('collapsed');
  });
};

const setProgressStep = (step, stepData) => {
  jq('.tutorial-progress div.current').removeClass('current');
  jq('.tutorial-progress div.group-block').removeClass('active');
  jq(`.tutorial-progress div[data-id=${step}]`).addClass('current');
  jq(`.tutorial-progress div[data-id=${step}]`).parent().addClass('active');

  jq('#current-step').text(stepData.step);
  jq('#total-steps').text(stepData.total);

  jq('.group-block').each((i, el) => {
    if(step > jq(el).data('step-complete')) {
      jq(el).addClass('group-complete');
    }
  });
};

export default {
  init,
  completeTour
};
